import axios from 'axios'
import Vue from 'vue'
import router from '../router';
import store from '../store/index';
import {
  MessageBox
} from 'element-ui';
import {
  message
} from './resetMessage';

// 超时时间
axios.defaults.timeout = 20000;
// 设置post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.withCredentials=true;
// http请求拦截器
axios.interceptors.request.use(config => {
  let token = store.state.token ? store.state.token : sessionStorage.getItem('token');
  if (token === null || token === 'null' || token === '') {} else {
    config.headers.auth = token;
    //每个请求参数默认加上当前登录账号id
    config.data +='&currentUserId='+store.state.userId;
  }

  return config
}, error => {
  return Promise.reject(error)
})
// http响应拦截器
axios.interceptors.response.use(res => { // 响应成功关闭loading
  if (res.data.ok == false) {
    if (res.data.errcode == 'JWT_TOKEN_EXPIRE') { //token过期
      // tip(res.data.errmsg);
      // beforeTologin('登录过期,请重新登录!');
      MessageBox.alert('登录过期,请重新登录！', '消息提示', {
        confirmButtonText: '确定',
        callback: action => {
          toLogin();
        }
      });
      return;
    } else if (res.data.errcode == 'JWT_CHECK_FAILURE') { //token 校验失败
      MessageBox.alert('token校验错误,请重新登录！', '消息提示', {
        confirmButtonText: '确定',
        callback: action => {
          toLogin();
        }
      });
      return;
    } else if (res.data.errcode == 'TSPT_TOKEN_NEED_INVALID') { //token 校验失败
      MessageBox.alert('必须登录，才能调用接口！', '消息提示', {
        confirmButtonText: '确定',
        callback: action => {
          toLogin();
        }
      });
      return;
    }


  }
  return res
}, error => {

  // 请求已发出，但是不在2xx的范围
  const {
    response
  } = error;
  if (response) {
    errorHandle(response.status, response.data.message);
  }
  console.log(error);
  return Promise.reject(error)
});

/**
 * 提示函数(同页面只显示一个弹窗提示)
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = (msg, type) => {
  message.error({
    showClose: true,
    message: msg
  })
}
//控制20s内不重复同类型提示消息
const beforeTologin = (msg) => {
  if (msg) {
    tip(msg);
  }
  toLogin();
}
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  store.commit('LOGOUT', null);
  setTimeout(() => {
    router.replace({
      path: '/userLogin',
      query: {
        redirect: router.currentRoute.fullPath
      }
    });
  }, 1000);
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  var errorMessage = '';
  switch (status) {
    case 400:
      errorMessage = '请求错误'
      break
    case 401:
      errorMessage = '未授权，请登录'
      beforeTologin(errorMessage);
      break
    case 403:
      errorMessage = '拒绝访问'
      break
    case 404:
      errorMessage = '未找到访问地址'
      break
    case 408:
      errorMessage = '请求超时'
      break
    case 500:
      errorMessage = '服务器内部错误'
      break
    case 501:
      errorMessage = '服务未实现'
      break
    case 502:
      errorMessage = '网关错误'
      break
    case 503:
      errorMessage = '服务不可用'
      break
    case 504:
      errorMessage = '网关超时'
      break
    case 505:
      errorMessage = 'HTTP版本不受支持'
      break
    default:
      errorMessage = other;
  }
  console.log("请求错误原因:" + errorMessage);
  tip(errorMessage, 'error');
}

export default axios;



// WEBPACK FOOTER //
// ./src/util/axiosbase.js